import React, { useState } from 'react';
import {
  TopToolbar,
  CreateButton,
  Button,
} from 'react-admin';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import type { PricingType } from './types';
import ConditionDiscountsImportDialog from './ConditionDiscountsImportDialog';

interface ConditionDiscountsActionsProps {
  pricingType: PricingType;
}

const ConditionDiscountsActions = ({ pricingType }: ConditionDiscountsActionsProps) => {
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);

  return (
    <TopToolbar>
      <CreateButton />
      <Button
        label="Import"
        onClick={() => setIsImportDialogOpen(true)}
        startIcon={<FileUploadIcon />}
      />
      <ConditionDiscountsImportDialog
        open={isImportDialogOpen}
        onClose={() => setIsImportDialogOpen(false)}
        pricingType={pricingType}
      />
    </TopToolbar>
  );
};

export default ConditionDiscountsActions;
